import _map from 'lodash/map';

import { IPropsWithClassName } from 'interfaces';
import Button, { ButtonProps } from '@atoms/Button';

import styles from './styles';

export interface ToggleButtonsProps extends IPropsWithClassName {
  items: ButtonProps[];
  onChange(item: ButtonProps): void;
}

const ToggleButtons = ({
  items,
  onChange,
  className,
}: ToggleButtonsProps) => {
  const componentStyles = styles.component(className);

  const makeButton = (props: ButtonProps) => (
    <Button
      key={String(props.children)}
      {...props}
      onClick={() => onChange(props)}
    />
  );
  const buttons = _map(items, (item) => makeButton(item));

  return (
    <div
      className={componentStyles}
    >
      {buttons}
    </div>
  );
};

export default ToggleButtons;
